export default __webpack_public_path__ + "static/tripwire-4881924ec5d350a0d394e06643bae85d.png";